
import axios from 'axios'
import setAuth from '@/common/js/global/setAuth'
import set from '../settings'

let settingsData = set();
window.baseURL = settingsData.baseURL;

axios.defaults.baseURL = window.baseURL + '/api';
axios.defaults.timeout = 6000;
// axios.defaults.baseURL =`https://${window.domain}.com/api`
axios.interceptors.request.use(function (config) {
    console.log('发请求前的信息', config)
    //在发送请求之前做某事
    //console.log(config)
    return config;
}, function (error) {
    //请求错误时做些事
    return Promise.reject(error);
});

window.axios = axios;
setAuth();